import { render, staticRenderFns } from "./allotUserCSG.vue?vue&type=template&id=cd8c19e8"
import script from "./allotUserCSG.vue?vue&type=script&lang=js"
export * from "./allotUserCSG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd8c19e8')) {
      api.createRecord('cd8c19e8', component.options)
    } else {
      api.reload('cd8c19e8', component.options)
    }
    module.hot.accept("./allotUserCSG.vue?vue&type=template&id=cd8c19e8", function () {
      api.rerender('cd8c19e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/role/allotUserCSG.vue"
export default component.exports